import { useEffect, useState } from "react"
import axios from "axios"
import { getCookie } from "../utils/getCookie"
export const useFetch = () => {

  const [load, setLoad] = useState(false)

const peticion = async(url = '', method = 'GET', data = []) => {
    const tokenJWT = getCookie('token')
   
    setLoad(true)
    const result = await axios({
        method: method,
        url: url,
        headers:  {
          'token': tokenJWT,
          'Content-Type': 'application/json'},
        data: JSON.stringify(data),
          
        
    })

    if(result.status === 200){
        setLoad(false)
        return result?.data

    }
}
return [peticion, load]
}
